/* Maiden — Apothecary. No dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    var s = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (window.Theme && window.Theme.currencySymbol ? window.Theme.currencySymbol : '$') + s;
  };

  /* ---------- Cart drawer ---------- */
  var drawer = {
    el: function () { return document.querySelector('[data-cart-drawer]'); },
    open: function () {
      var d = this.el(); if (!d) return;
      d.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = d.querySelector('[data-drawer-close]'); if (close) close.focus();
    },
    close: function () {
      var d = this.el(); if (!d) return;
      d.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    refresh: function () {
      var d = this.el(); if (!d) return Promise.resolve();
      return fetch(window.location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer]');
          if (fresh) d.innerHTML = fresh.innerHTML;
        });
    }
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && document.querySelector('[data-cart-drawer]')) {
      e.preventDefault();
      drawer.refresh().then(function () { drawer.open(); });
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('.drawer__scrim')) {
      e.preventDefault(); drawer.close(); return;
    }
    var menuBtn = e.target.closest('[data-menu-toggle]');
    if (menuBtn) {
      var menu = document.querySelector('[data-menu]');
      if (menu) {
        var open = menu.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-line'), 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') drawer.close();
  });

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function () {
      updateCount();
      return drawer.refresh();
    });
  }

  function updateCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
        });
      });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var next = Number(input.value || 1) + Number(step.getAttribute('data-qty-step'));
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form: variants, gallery, sticky bar ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('.product-form') || root.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var submit = form && form.querySelector('[data-atc]');
    var submitText = submit && submit.querySelector('[data-atc-text]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-opt-group]'), function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function match() {
      var want = selected();
      return product.variants.find(function (v) {
        return want.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function render() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        var show = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.textContent = show ? money(v.compare_at_price) : '';
        priceWas.hidden = !show;
      }
      if (submit) {
        submit.disabled = !v.available;
        if (submitText) submitText.textContent = v.available ? (submit.getAttribute('data-label-add') || 'Add to cart') : (submit.getAttribute('data-label-sold') || 'Sold out');
      }
      document.querySelectorAll('[data-satc-price]').forEach(function (n) { n.textContent = money(v.price); });
      if (v.featured_image && v.featured_image.src) showImage(v.featured_image.src);
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-opt-group]')) render();
    });

    /* gallery */
    var mainImg = root.querySelector('[data-gal-main] img');
    function showImage(src) {
      if (!mainImg || !src) return;
      mainImg.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
    }
    var galThumbs = root.querySelectorAll('[data-gal-thumb]');
    galThumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        galThumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        showImage(btn.getAttribute('data-full'));
      });
    });

    /* gallery arrow navigation */
    var galPrev = root.querySelector('[data-gal-prev]');
    var galNext = root.querySelector('[data-gal-next]');
    function goToThumb(delta) {
      if (!galThumbs.length) return;
      var current = 0;
      galThumbs.forEach(function (b, i) { if (b.getAttribute('aria-current') === 'true') current = i; });
      var next = current + delta;
      if (next < 0) next = galThumbs.length - 1;
      if (next >= galThumbs.length) next = 0;
      galThumbs[next].click();
    }
    if (galPrev) galPrev.addEventListener('click', function () { goToThumb(-1); });
    if (galNext) galNext.addEventListener('click', function () { goToThumb(1); });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (document.body.hasAttribute('data-atc-checkout')) return; /* let it post and redirect to checkout */
        if (!document.querySelector('[data-cart-drawer]')) return; /* cart page mode */
        e.preventDefault();
        var fd = new FormData(form);
        if (submitText) submitText.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (submitText) submitText.textContent = submit.getAttribute('data-label-add') || 'Add to cart';
            updateCount();
            return drawer.refresh().then(function () { drawer.open(); });
          })
          .catch(function () {
            if (submitText) submitText.textContent = 'Try again';
          });
      });
    }

    render();

    /* sticky bar */
    var satc = document.querySelector('[data-satc]');
    var anchor = root.querySelector('[data-atc]');
    if (satc && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        satc.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ---------- Quiz ---------- */
  function initQuiz(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var bar = root.querySelector('[data-quiz-bar]');
    var counter = root.querySelector('[data-quiz-counter]');
    var answers = {};
    var idx = 0;
    var total = steps.filter(function (s) { return s.getAttribute('data-quiz-step') !== 'result'; }).length;

    function show(i) {
      idx = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      if (bar) bar.style.width = Math.round((Math.min(i + 1, total) / total) * 100) + '%';
      if (counter) counter.textContent = i < total ? 'Question ' + (i + 1) + ' of ' + total : '';
      var h = steps[i] && steps[i].querySelector('h1, h2');
      if (h) h.setAttribute('tabindex', '-1'), h.focus();
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-answer]');
      if (opt) {
        var step = opt.closest('[data-quiz-step]');
        answers[step.getAttribute('data-quiz-key')] = opt.getAttribute('data-quiz-answer');
        var next = idx + 1;
        if (next >= steps.length) return;
        if (steps[next].getAttribute('data-quiz-step') === 'result') renderResult();
        show(next);
        return;
      }
      if (e.target.closest('[data-quiz-back]')) { if (idx > 0) show(idx - 1); return; }
      if (e.target.closest('[data-quiz-restart]')) { answers = {}; show(0); return; }
    });

    function renderResult() {
      var key = answers.goal || 'calm';
      root.querySelectorAll('[data-quiz-outcome]').forEach(function (o) {
        o.hidden = o.getAttribute('data-quiz-outcome') !== key;
      });
      var verdictKey = answers.skin === 'reactive' ? 'reactive'
        : (answers.goal === 'focus' ? 'focus'
        : (answers.goal === 'hormone' ? 'hormone' : 'default'));
      var shown = null;
      root.querySelectorAll('[data-quiz-verdict]').forEach(function (n) {
        var match = n.getAttribute('data-quiz-verdict') === verdictKey;
        n.hidden = !match;
        if (match) shown = n;
      });
      if (!shown) {
        var fallback = root.querySelector('[data-quiz-verdict="default"]');
        if (fallback) { fallback.hidden = false; shown = fallback; }
      }
      var cautious = verdictKey === 'reactive';
      root.querySelectorAll('[data-quiz-cta]').forEach(function (btn) {
        var label = cautious ? btn.getAttribute('data-label-cautious') : btn.getAttribute('data-label-default');
        if (label) btn.textContent = label;
        btn.classList.toggle('btn--ghost', cautious);
      });

      var gentle = ['sensitive', 'reactive', 'unsure'].indexOf(answers.skin) > -1;
      root.querySelectorAll('[data-quiz-adhesive]').forEach(function (n) {
        n.hidden = n.getAttribute('data-quiz-adhesive') !== (gentle ? 'sensitive' : 'standard');
      });
      root.querySelectorAll('[data-quiz-guidance]').forEach(function (n) {
        n.hidden = n.getAttribute('data-quiz-guidance') !== (answers.history || 'never');
      });
      try { localStorage.setItem('maiden_quiz', JSON.stringify(answers)); } catch (err) {}
    }

    show(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    document.querySelectorAll('[data-quiz-root]').forEach(initQuiz);
    updateCount();
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product-root]').forEach(initProduct);
    e.target.querySelectorAll('[data-quiz-root]').forEach(initQuiz);
  });
})();

// Longform sticky CTA — reveals past 55% of the page
(function () {
  var bar = document.querySelector('[data-lp-sticky]');
  if (!bar) return;
  function sync() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    bar.hidden = !(max > 0 && (window.scrollY / max) > 0.55);
  }
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();

// Quantity multiplies the price shown on the add-to-cart button
(function () {
  var form = document.querySelector('.product-form');
  if (!form) return;
  var qty = form.querySelector('[name="quantity"]');
  var out = document.querySelector('[data-price-now]');
  if (!qty || !out) return;
  var unit = parseFloat(out.getAttribute('data-unit-cents') || '0');
  function money(cents) {
    var fmt = out.getAttribute('data-money') || '${{amount}}';
    return fmt.replace('{{amount}}', (cents / 100).toFixed(2));
  }
  var cmp = document.querySelector('[data-compare-now]');
  function sync() {
    var u = parseFloat(out.getAttribute('data-unit-cents') || '0');
    var n = Math.max(1, parseInt(qty.value, 10) || 1);
    if (u > 0) out.textContent = money(u * n);
    if (cmp) {
      var c = parseFloat(cmp.getAttribute('data-compare-cents') || '0');
      if (c > 0) cmp.textContent = money(c * n);
    }
  }
  qty.addEventListener('input', sync);
  qty.addEventListener('change', sync);
  form.addEventListener('click', function (e) { if (e.target.closest('[data-qty-step]')) setTimeout(sync, 0); });
  sync();
})();
